module.exports = __webpack_public_path__ + "assets/img/left-layer-1-ace43c7f.png";